export const ORDER_STATUS: { [key: string]: { text: string } } = {
  INIT_FLOW: { text: 'Tu cliente inició el proceso' },
  CUSTOMER_IDENTIFICATION: { text: 'Ya se identificó con su DNI' },
  CONTACT_INFORMATION: { text: 'Ya completó sus datos personales' },
  SMS_VERIFICATION: { text: 'Ya validó su celular' },
  REPAYMENT_TERMS: { text: 'Ya eligió el plan de cuotas' },
  IDENTITY_VERIFICATION_START: { text: 'Ya realizó biometría' },
  IDENTITY_VERIFICATION_STATUS_PENDING: { text: 'Biometría en curso' },
  PAYMENT_METHOD: { text: 'Ya eligió el modo de pago' },
  REVIEW_AND_SUBMIT: { text: 'Ya confirmó la operación' },
  REVIEW_AND_SEND_LINK: { text: 'Tu cliente debe aceptar los términos y condiciones' },
  FIN: { text: '¡Listo! Ya podés entregar el producto' },
};

export const REJECTION_REASON_MAP: { [key: string]: string } = {
  CUSTOMER_RISK_EVALUATION_REJECTED: 'Tu cliente no cumple con las políticas de riesgo crediticio',
  SMS_OTP_VALIDATION_ATTEMPTS_LIMIT: 'Tu cliente ha superado la cantidad de intentos de validación OTP celular',
  TERMS_NOT_ACCEPTED: 'Tu cliente no ha aceptado los términos y condiciones del préstamo',
  INSUFFICIENT_FUNDS:
    'Tu cliente no cuenta con fondos suficientes en la tarjeta para realizar la transacciónen o existe alguna restricción sobre los límites de operación aplicados por su banco',
  IDENTITY_VERIFICATION_ATTEMPTS_LIMIT:
    'Tu cliente ha superado la cantidad de intentos para realizar la validación de identidad',
};
